import {
  openDatabaseAsync as openExpoSqliteDatabaseAsync,
  type SQLiteDatabase,
  type SQLiteOpenOptions,
} from "@-/com.npmjs.expo-sqlite";
import { withSqliteBusyRetry } from "#with-sqlite-busy-retry";

/**
 * Open a SQLite connection by name. Thin pass-through to expo-sqlite's
 * `openDatabaseAsync` — expo-sqlite is the app's SQLite engine.
 *
 * This is the ONE place an expo-sqlite connection enters the app (actor
 * local-only, content, static), so it is also where `SQLITE_BUSY` containment is
 * installed: `withSqliteBusyRetry` is applied to the raw handle BEFORE any other
 * wrapper, which makes it structurally impossible to hold a queryable expo-sqlite
 * connection that surfaces a transient "database is locked" to callers. See
 * `with-sqlite-busy-retry.ts` for the failure this removes.
 */
export async function openSqliteDatabase(
  databaseName: string,
  options?: SQLiteOpenOptions,
  directory?: string,
): Promise<SQLiteDatabase> {
  if (
    databaseName === "actor.db" ||
    databaseName === "actor-guest-handoff.db" ||
    directory?.includes(".haniverse-generations")
  ) {
    throw new Error("Actor databases must be opened through their Turso generation owner");
  }
  return withSqliteBusyRetry(await openExpoSqliteDatabaseAsync(databaseName, options, directory));
}

export { type SQLiteDatabase, type SQLiteOpenOptions } from "@-/com.npmjs.expo-sqlite";
